<template>
  <div class="toolsList">
    <div @click="undo()" class="toolItem" style="pointer-events: none; color:#666;">
      <svg-icon icon-class="undo" />
    </div>
    <div @click="redo()" class="toolItem" style="pointer-events: none; color:#666;">
      <svg-icon icon-class="redo" />
    </div>
    <div @click="del()" class="toolItem" style="margin-right: 10px;">
      <svg-icon icon-class="delete" />
    </div>

    <template v-for="(item,index) in graphicsToolList">
      <div v-if="!item.hidden"
           :class="['toolItem',index === toolIndex ? 'active':'']"
           :key="'graphics' + index"
           @click="toolClick(item,index)">
        <svg-icon v-if="item.iconSvg" :icon-class="item.iconSvg" />
        <img
          v-else-if="item.iconPath"
          :src="item.iconPath"
          draggable="true"
          @dragstart="dragstart($event, item)"
          effectAllowed="copy"
          dropEffect="copy">
        <span v-else>{{item.title}}</span>
      </div>

    </template>

    <button class="save-button" @click="doDataExporter">保存</button>
    <button class="save-button" @click="doSelectFile">导入</button>
    <div class="file">
      <input ref="file"
             type="file"
             @change="fileChange">
    </div>
    <el-dialog
      title="导出数据预览"
      :visible.sync="jsonViewerVisible"
      width="40%">
      <json-viewer theme="my-awesome-json-theme"
                   copyable
                   :value="labelingResults"></json-viewer>
    </el-dialog>

    <el-dialog
      title="导入数据预览"
      :visible.sync="importDataViewerVisible"
      @closed="importDialogClosed"
      width="50%">
      <div class="tip-title">
        点击确定导入后，会清理原来显示的数据，加载显示导入的数据，再次点击保存后，才会覆盖服务端保存的数据
        <button @click="sureImportData()">确定导入</button>
      </div>
      <json-viewer theme="my-awesome-json-theme"
                   copyable
                   :value="importLabelingData"></json-viewer>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable no-underscore-dangle */
/* eslint-disable global-require */
import { fabric, historyManager, toolsConfig, LayerManager, EventManager, eventStatus, eventHub } from '@aibee/vincent';
import axios from 'axios';
import { mapGetters } from 'vuex';
import { vec4, mat4 } from 'gl-matrix';
import JsonViewer from 'vue-json-viewer';
import layerManager from '@aibee/vincent/core/layerManager';
import { Events, EventHub as EventHubOwlly } from '@aibee/owlly';
import debounce from 'lodash.debounce';
import panoramaData from './config';
import { dataExporter } from '@/components/mapComponents/dataTransform';
import request from '@/utils/request';
import graphicConverter from '@/components/mapComponents/oldGraphicConverter';
import convertData from '@/components/mapComponents/convertData';
import { listPanoramas } from '@/api/map';

import testData from '@/components/mapComponents/data/p12f110';

export default {
  components: { JsonViewer },
  data() {
    return {
      importDataViewerVisible: false, // 导入数据
      importLabelingData: {}, // 导入数据
      jsonViewerVisible: false,
      labelingResults: {},
      graphicsToolList: [],
      toolIndex: 0,
      isDragging: false,
      selectedIcon: null,
      drawer: false,
      currentShape: null,
      panoramaList: [],
      toolConfig: [
        {
          type: 'DirectSelect',
          hidden: false,
        },
        {
          title: '全景点',
          type: 'PanoramaPoint',
          loader: () => require('@/components/mapComponents/shapes/PanoramaPoint.js'),
          hidden: true,
          shapeParams: {
            left: 0,
            top: 0,
            strokeWidth: 2,
            lockScalingX: true,
            lockScalingY: true,
            lockRotation: true,
            hasBorders: false,
            hasControls: false,
            selectable: true,
            radius: 5,
            fill: 'blue',
          },
        },
        {
          title: '点',
          type: 'CirclePoint',
          hidden: true,
          loader: () => require('@/components/mapComponents/shapes/CirclePoint.js'),
          iconSvg: 'point',
          shapeParams: {
            left: 0,
            top: 0,
            strokeWidth: 1,
            lockScalingX: true,
            lockScalingY: true,
            lockRotation: true,
            hasBorders: false,
            hasControls: false,
            selectable: true,
            radius: 3,
            fill: 'blue',
          },
        },
        {
          title: '线',
          type: 'CommonLine',
          hidden: true,
          loader: () => require('@/components/mapComponents/shapes/CommonLine.js'),
          shapeParams: {
            lockScalingX: true,
            lockScalingY: true,
            lockRotation: true,
            hasBorders: true,
            hasControls: false,
            perPixelTargetFind: true,
            selectable: true,
            fill: 'blue',
            strokeWidth: 2,
            points: [],
          },
        },
        {
          title: '路径',
          type: 'LinePoint',
          iconSvg: 'route',
          bringToFront: true,
          shapeParams: {
            lockScalingX: true,
            lockScalingY: true,
            lockRotation: true,
            hasBorders: false,
            hasControls: false,
            selectable: true,
            perPixelTargetFind: true,
          },
        },
        {
          title: '多边形',
          iconSvg: 'polygon',
          type: 'SkeletonPolygon',
          shapeParams: {
            lockScalingX: true,
            lockScalingY: true,
            lockRotation: true,
            hasBorders: false,
            hasControls: false,
            selectable: true,
            perPixelTargetFind: true,
          },
        },
        {
          title: '直梯',
          type: 'Elevator',
          iconSvg: 'elevator',
          loader: () => require('@/components/mapComponents/shapes/elevator.js'),
          shapeParams: {},
        },
        {
          title: '扶梯',
          type: 'Escalator',
          iconSvg: 'escalator',
          loader: () => require('@/components/mapComponents/shapes/escalator.js'),
          shapeParams: {},
        },
        {
          title: '大屏',
          type: 'Screen',
          iconSvg: 'screen',
          loader: () => require('@/components/mapComponents/shapes/screen.js'),
          shapeParams: {},
        },
      ],
      lastClickGroup: null, // 上次点击组
      lastClickShape: null, // 最后一次点击元素
    };
  },
  computed: {
    ...mapGetters(['floorInfo']),
    floorId() {
      return this.$route.query.floor_id;
    },
    placeId() {
      return this.$route.query.place_id;
    },
    svgSize() {
      return this.$store.state.app.floorSvgSize;
    },
    transData() {
      return this.$route.query.trans;
    },
  },
  watch: {
    floorInfo() {
      if (this.floorInfo) this.loadPanoramas();
    },
    svgSize() {
      if (this.svgSize) this.loadPanoramas();
    },
  },
  beforeDestroy() {
    layerManager.getCurrentLayer().canvas.clear();
    eventHub.$off('shapeTypeChange');
    eventHub.$off('shapeClick');
    EventManager.eventStatus.setShapeType('DirectSelect');
  },
  mounted() {
    this.setToolsConfig();
    this.initToolBar();
    eventHub.$on('shapeTypeChange', this.toolTypeChange);

    eventHub.$on('shapeClick', this.shapeClick);
    // if (this.floorInfo) this.loadPanoramas();

    eventHub.$on('shape:add', this.debounceReloadPanoramic);
    eventHub.$on('shape:removed', this.debounceReloadPanoramic);
    eventHub.$on('shapeMoveClick', this.debounceReloadPanoramic);
    eventHub.$on('debounceReloadPanoramic', this.debounceReloadPanoramic);
    // eventStatus.setCursorPointConfig({ radius: 2, fill: 'red' });
    eventStatus.initCursorPoint();
  },
  methods: {
    // 2D -> 3D
    glMatrixUp(upTrans, x, y) {
      // console.log(upTrans, x, y);
      const v4 = vec4.create();
      vec4.set(v4, x, y, 1, 1);

      const m4 = mat4.fromValues(...upTrans);

      const rs = vec4.create();
      vec4.transformMat4(rs, v4, m4);
      return { x: rs[0], y: rs[1], z: 0 };
    },
    // 3D -> 2D
    glMatrixDown(downTrans, x, y, z) {
      // console.log(downTrans, x, y, z);
      const v4 = vec4.create();
      vec4.set(v4, x, y, z, 1);

      const m4 = mat4.fromValues(...downTrans);

      const rs = vec4.create();
      vec4.transformMat4(rs, v4, m4);
      return { x: rs[0], y: rs[1] };
    },
    async loadPanoramas() {
      if (this.floorInfo && this.svgSize) {
        let res = null;
        try {
          res = await this.loadListPanoramas();
          if (res && res.data && res.data.data && res.data.data.panorama_list) {
            this.panoramaList = res.data.data.panorama_list.filter(t => t.visible) || [];
          }
        } catch (e) {
          this.$message.error('获取全景数据出错');
        }

        const currentLayer = LayerManager.getCurrentLayer();
        const PanoramaPoint = currentLayer.getAllObjects().filter(item => item.type === 'PanoramaPoint');
        // console.log(currentLayer.getAllObjects().filter(item => item.type === 'PanoramaPoint').map(item => item.type));
        PanoramaPoint.forEach((item) => {
          currentLayer.removeObject(item);
        });

        // 如果有全景点数据
        if (this.panoramaList && this.panoramaList.length > 0) {
          // 如果有对齐数据
          if (this.floorInfo[1].floor_cmap_align_param) {
            const tm = JSON.parse(this.floorInfo[1].floor_cmap_align_param);
            const dt = tm.transformMatrices.downTrans;
            const ut = tm.transformMatrices.upTrans;
            this.downTrans = dt;
            this.upTrans = ut;
            // 加载显示全景点
            const svgSize = this.svgSize;
            this.panoramaList.forEach((pano, idx) => {
              const point = this.glMatrixDown(dt, pano.coordinate.position_x, pano.coordinate.position_y, pano.coordinate.position_z);

              // test upTrans
              // console.log('downTrans', pano.coordinate.position_x, pano.coordinate.position_y, pano.coordinate.position_z, '-->', point);
              // const coordinate = this.glMatrixUp(ut, point.x, point.y);
              // console.log('upTrans', point, '-->', coordinate);
              // console.log('------------------------------', pano.seq_id);

              const panoConfig = JSON.parse(JSON.stringify(this.toolConfig[1]));
              panoConfig.shapeParams.left = point.x - svgSize.width / 2;
              panoConfig.shapeParams.top = point.y - svgSize.height / 2;
              panoConfig.shapeParams.selectable = false;
              panoConfig.shapeParams.pano_id = pano.id;
              panoConfig.shapeParams.is_route = '1';
              panoConfig.shapeParams.property = {
                panorama_id: pano.seq_id,
                pano_id: pano.id,
                seq_id: pano.seq_id,
                is_route: '1',
              };
              LayerManager.getCurrentLayer().addObject('PanoramaPoint', panoConfig);
            });
          } else {
            this.$message.error('有全景点数据，但无对齐数据，无法显示全景点');
          }
        }
        this.doDataImport();
        if (res && res.data && res.data.data) {
          eventHub.$emit('LoadPanoramas', (res && res.data) ? res.data.data : {});
        }
      }
    },
    async loadListPanoramas() {
      if (!this.$route.query.vr_id) {
        return this.$message.warning('获取全景数据需要先在对应的楼层填写vr_id');
      }
      return listPanoramas(this.$route.query.vr_id);
    },
    drawerClose() {
      this.currentShape = null;
    },
    shapeClick(shape) {
      // 处理多边形点击，还原高亮显示
      if (this.lastClickGroup && this.lastClickGroup._objects) {
        this.lastClickGroup._objects.forEach((t) => {
          t.set('borderColor', 'red').set('stroke', 'red').setCoords();
        });
        this.lastClickGroup.canvas.renderAll();
        if (shape !== this.lastClickShape) {
          this.lastClickGroup = null;
        }
      }
      if (eventStatus.currentToolType === 'DirectSelect') {
        if (['Elevator', 'Escalator', 'Screen', 'PanoramaPoint'].includes(shape.type)) {
          shape.graphic_type = shape.type;
          if (shape.type === 'PanoramaPoint') {
            EventHubOwlly.emit(Events.PANORAMA_SELECTED, shape.property.panorama_id);
          }
        } else if (shape.type === 'CirclePoint') {
          shape.graphic_type = 'point';

          // 处理多边形点击，高亮显示，右侧显示分组属性
          if (shape.isGroup && shape.groupData) {
            let groupIndex = shape.groupData.findIndex(item => item === this.lastClickGroup) + 1;
            // 排除掉不是多边形的分组
            while (shape.groupData[groupIndex] && shape.groupData[groupIndex].type !== 'SkeletonPolygon' && groupIndex < shape.groupData.length) {
              groupIndex += 1;
            }
            if (groupIndex >= shape.groupData.length) {
              groupIndex = 0;
              this.lastClickGroup = null;
            } else {
              const groupObjects = shape.groupData[groupIndex]._objects;
              groupObjects.forEach((t) => {
                t.set('borderColor', 'blue').set('stroke', 'blue').setCoords();
              });
              this.lastClickGroup = shape.groupData[groupIndex];
              shape.canvas.renderAll();
            }
          }
        } else if (shape.type === 'CommonLine') {
          shape.graphic_type = 'CommonLine';
        } else {
          shape.graphic_type = 'block';
        }
        if (!shape.property && shape.id) {
          shape.property = {
            id: shape.id,
          };
        }
        // 如果有分组点击
        if (this.lastClickGroup) {
          if (this.lastClickGroup.type === 'SkeletonPolygon') {
            this.lastClickGroup.graphic_type = 'polygon';
          }
          this.currentShape = this.lastClickGroup;
        } else {
          this.currentShape = shape;
        }
        this.drawer = !this.drawer;
      } else {
        this.currentShape = null;
      }
      this.lastClickShape = shape;
      eventHub.$emit('routeCurrentShape', this.currentShape);
    },
    toolTypeChange(type) {
      this.graphicsToolList.forEach((tool, index) => {
        if (tool.type === type) {
          this.toolClick(tool, index);
        }
      });
    },
    toolClick(tool, index) {
      if (tool.ignoreActive) return;
      this.changeTool(tool, index);
    },
    setToolsConfig() {
      // // 引入全部工具
      // const config = [
      //   'DirectSelect',
      //   'CirclePoint',
      //   'CommonLine',
      //   'LinePoint',
      //   'SkeletonPolygon',
      // ];
      toolsConfig.setConfigTools(this.toolConfig);
      // 设置可吸附图形类型
      eventStatus.setSnapShapeTypes(['Elevator', 'Escalator', 'Screen']); // , 'PanoramaPoint'
    },
    initToolBar() {
      this.graphicsToolList = toolsConfig.getTools().filter(t => this.toolConfig.some(c => c.type === t.type));
      console.log('this.graphicsToolList==>', this.graphicsToolList);
      const firstTool = this.graphicsToolList[0];
      if (!firstTool) return;
      this.changeTool(firstTool, 0);
      EventManager.eventStatus.setShapeType(firstTool.type);
    },
    changeTool(tool, index) {
      const { canvasConfig } = tool;
      if (canvasConfig) {
        const currentLayer = LayerManager.getCurrentLayer();
        if (!currentLayer) {
          return false;
        }
        Object.keys(canvasConfig).forEach((item) => {
          currentLayer.canvas[item] = canvasConfig[item];
        });
      }
      this.toolIndex = index;
      EventManager.eventStatus.setShapeType(tool.type);
      return tool;
    },
    undo() {
      // historyManager.undo();
    },
    redo() {
      // historyManager.redo();
    },
    del() {
      LayerManager.getCurrentLayer().removeObject(eventStatus.leftClickObject || eventStatus.rightClickObject);
      setTimeout(() => {
        eventStatus.reset();
      }, 100);
    },
    dragstart(e, item) {
      this.isDragging = true;
      this.selectedIcon = item;
      e.dataTransfer.setData('materailItem', JSON.stringify(item));
    },
    doDataExporter() {
      const allLayers = LayerManager.getAllLayers();
      const labelingResults = dataExporter(allLayers, this.toolConfig);
      this.labelingResults = convertData(labelingResults);
      this.jsonViewerVisible = true;

      // 坐标点转换成基于左上角0 0
      const svgSize = this.svgSize;
      const transformX = svgSize.width / 2;
      const transformY = svgSize.height / 2;
      Object.keys(this.labelingResults.point_dict).forEach((key) => {
        const point = this.labelingResults.point_dict[key];
        point.x += transformX;
        point.y += transformY;
      });
      // this.labelingResults.graphic_list = this.labelingResults.graphic_list.filter(item => item.group_type !== 'PanoramaPoint');
      // 过滤掉垃圾数据（line开始和结束点id一样的）
      // eslint-disable-next-line eqeqeq
      this.labelingResults.graphic_list = this.labelingResults.graphic_list.filter(t => !(t.graphic_type == 'line' && t.graphic_data.length == 2 && t.graphic_data[0] == t.graphic_data[1]));
      console.log('labelingResults', this.labelingResults);
      request({
        url: '/deployment-service/roadnetwork/post_labeling_result',
        method: 'post',
        data: {
          floor_id: this.floorId, // 楼层ID，必填
          place_id: this.placeId, // 场ID 必填
          result: this.labelingResults,
        },
      }).then((rs) => {
        if (rs.error_no === 0) {
          this.$message({ type: 'success', message: '保存成功' });
        }
      });
    },
    // 使用导入数据
    storageImport() {
      const importDataStr = sessionStorage.getItem('importData');

      try {
        const importData = JSON.parse(importDataStr);
        if (importData && importData.graphic_list && importData.point_dict) {
          const labelingResults = importData;
          // 坐标点转换成基于左上角0 0
          const svgSize = this.svgSize;
          const transformX = svgSize.width / 2;
          const transformY = svgSize.height / 2;
          Object.keys(labelingResults.point_dict).forEach((key) => {
            const point = labelingResults.point_dict[key];
            point.x -= transformX;
            point.y -= transformY;
          });
          // 过滤掉垃圾数据（line开始和结束点id一样的）
          // eslint-disable-next-line eqeqeq
          labelingResults.graphic_list = labelingResults.graphic_list.filter(t => !(t.graphic_type == 'line' && t.graphic_data.length == 2 && t.graphic_data[0] == t.graphic_data[1]));
          // 将原来type=pano和model转换为数字
          labelingResults.graphic_list.forEach((item) => {
            // 转换车位类型
            if (this.transData && item.graphic_type === 'point' && item.property && item.property.type === '0' && new RegExp(`^[${this.transData}]{1}\\d+$`).test(item.property.name)) {
              item.property.type = '15';
            }
            if (item.graphic_type === 'point' && item.property && item.property.type === 'pano') {
              item.property.type = '91';
            }
            if (item.graphic_type === 'point' && item.property && item.property.type === 'model') {
              item.property.type = '92';
            }
          });
          this.labelingResults = convertData(labelingResults);
          console.log('labelingResults', this.labelingResults);
          // dataImporter(this.labelingResults, this.toolConfig);
          graphicConverter(this.labelingResults);
          this.initPanoramicPathGroup();
          sessionStorage.removeItem('importData');
          return true;
        }
        return false;
      } catch (ex) {
        console.log(ex);
        return false;
      }
    },
    doDataImport() {
      if (this.storageImport()) {
        return;
      }
      const params = {
        floor_id: this.floorId, // 楼层ID，必填
        place_id: this.placeId, // 场ID 必填
      };
      request({
        url: '/deployment-service/roadnetwork/labeling_result',
        get: 'get',
        params,
      }).then((rs) => {
        // const rs = testData;
        if (rs.error_no === 0 && rs.data.length > 0) {
          const labelingResults = rs.data[0].labeling_results;
          // 坐标点转换成基于左上角0 0
          const svgSize = this.svgSize;
          const transformX = svgSize.width / 2;
          const transformY = svgSize.height / 2;
          Object.keys(labelingResults.point_dict).forEach((key) => {
            const point = labelingResults.point_dict[key];
            point.x -= transformX;
            point.y -= transformY;
          });
          // 过滤掉垃圾数据（line开始和结束点id一样的）
          // eslint-disable-next-line eqeqeq
          labelingResults.graphic_list = labelingResults.graphic_list.filter(t => !(t.graphic_type == 'line' && t.graphic_data.length == 2 && t.graphic_data[0] == t.graphic_data[1]));
          // 将原来type=pano和model转换为数字
          labelingResults.graphic_list.forEach((item) => {
            // 转换车位类型
            if (this.transData && item.graphic_type === 'point' && item.property && item.property.type === '0' && new RegExp(`^[${this.transData}]{1}\\d+$`).test(item.property.name)) {
              item.property.type = '15';
            }
            if (item.graphic_type === 'point' && item.property && item.property.type === 'pano') {
              item.property.type = '91';
            }
            if (item.graphic_type === 'point' && item.property && item.property.type === 'model') {
              item.property.type = '92';
            }
          });
          this.labelingResults = convertData(labelingResults);
          console.log('labelingResults', this.labelingResults);
          // dataImporter(this.labelingResults, this.toolConfig);
          graphicConverter(this.labelingResults);
          this.initPanoramicPathGroup();
        }
      });
    },
    initPanoramicPathGroup() {
      if (!this.$parent.$parent.leftShow || !this.$parent.$parent.rightShow) {
        return;
      }
      const groupPaths = [];
      const allObjects = LayerManager.getCurrentLayer().getAllObjects().filter(obj => obj.type === 'LinePoint');
      allObjects.forEach((obj) => {
        // eslint-disable-next-line no-underscore-dangle
        const one = obj._objects.filter(t => t.type === 'CirclePoint').map((point) => {
          const x = point.left + this.svgSize.width / 2;
          const y = point.top + this.svgSize.width / 2;
          const rs = this.glMatrixUp(this.upTrans, x, y);
          return rs;
        });
        groupPaths.push(one);
      });
      eventHub.$emit('ReloadPathGroup', groupPaths);
    },
    // eslint-disable-next-line func-names
    debounceReloadPanoramic: debounce(function () {
      this.initPanoramicPathGroup();
    }, 2000),
    doSelectFile() {
      this.$refs.file.click();
    },
    fileChange(e) {
      const selectedFile = e.target.files[0];// 获取读取的File对象
      if (!selectedFile) {
        this.importLabelingData = {};
        return;
      }
      const reader = new FileReader();// 这里是核心！！！读取操作就是由它完成的。
      reader.readAsText(selectedFile);// 读取文件的内容
      const self = this;
      // eslint-disable-next-line func-names
      reader.onload = function () {
        try {
          const json = JSON.parse(this.result);
          self.importLabelingData = json;
          self.importDataViewerVisible = true;
        } catch (ex) {
          self.$message({
            type: 'error',
            message: '不是json文件或者json格式错误',
          });
        }
      };
    },
    sureImportData() {
      sessionStorage.setItem('importData', JSON.stringify(this.importLabelingData));
      setTimeout(() => {
        window.location.reload();
      }, 200);
    },
    importDialogClosed() {
      this.importLabelingData = {};
    },
  },
};
</script>

<style lang="scss" scoped>
.toolsList {
  border-top: 1px solid #333;
  height: 30px;
  display: flex;
  background-color: #1b1b1b;
  align-items: center;
  padding: 0 10px;
  .toolItem {
    cursor: pointer;
    color: white;
    font-size: 20px;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 30px;
    padding: 0 5px;
    // margin: 0 10px;
    &.active {
      background-color: #535353;
    }
    &:hover {
      color: #aaa;
    }
  }
  img {
    width: 15px;
    display: block;
  }
  span {
    display: block;
    color: white;
    cursor: pointer;
  }

  .rightDrawer {
    position: fixed;
    width: 280px;
    height: 100%;
    right: 0;
    top: 100px;
    z-index: 99;
  }
  .save-button {
    display: inline-block;
    line-height: 15px;
    color: black;
    border: 1px solid white;
    border-radius: 15px;
    cursor: pointer;
    margin-right: 10px;
  }
  .file {
    display: inline-block;
    width: 0;
    height: 0;
    opacity: 0;
    overflow: hidden;
  }

  .tip-title {
    color: red;
    padding: 5px;
  }
}
</style>
<style lang="less">
.toolsList {
  .el-dialog__body{
    padding: 0;
  }
}
</style>
